module.exports = __webpack_public_path__ + "static/media/harness.b705057a.svg";